/** @format */

import React, {useState} from 'react';
import './toggle_button.sass';

const ToggleButton = ({
    isOn = false,
    onText = 'Enabled',
    offText = 'Disabled',
    onToggle = () => {}
}) => {
    return (
        <div className={`toggle ${isOn ? 'active' : ''}`} onClick={onToggle.bind(this, !isOn)}>
            <div className="toggle-content">{isOn ? onText : offText}</div>
            <div className="toggle-slider"></div>
        </div>
    );
};

const PushButtonToggle = ({
    isOn = false,
    onText = 'Enabled',
    offText = 'Disabled',
    onToggle = () => {}
}) => {
    return (
        <div
            className={`btn btn-sm ${isOn ? 'btn-secondary' : 'btn-outline-secondary'}`}
            onClick={onToggle.bind(this, !isOn)}>
            <div className="push-button-toggle-content">{isOn ? onText : offText}</div>
        </div>
    );
};

const PushButtonToggleChild = ({isOn = false, onToggle = () => {}, ...props}) => {
    return (
        <button
            className={`btn btn-sm ${isOn ? 'btn-secondary' : 'btn-outline-secondary'}`}
            onClick={onToggle.bind(this, !isOn)}>
            {isOn ? props.children[0] : props.children[1]}
        </button>
    );
};

export default ToggleButton;
export {PushButtonToggle, PushButtonToggleChild};
